<template>
<div class="contactTemp" v-if="info" style="width: 2.4rem;">
    <div class="contactUs" @click="contactPopFun">
        <img v-if="info&&info.live_info&&info.live_info.bid_type==1"  src="../assets/img/bid_type_icon3.png" alt="">
        <img v-else  src="../assets/img/icon_phone.png" alt="">
        <span>{{info&&info.live_info&&info.live_info.bid_type==1?"刷新":"客服"}}</span>
    </div>
    <van-popup v-model="contactPop" :close-on-click-overlay="true" round>
        <div class="contactPop">
            <h3>竞投咨询</h3>
            <p>服务时间：{{info.bid_ask_time}}</p>
            <ul>
                <li class="icon_wx" @click="qrPop=true">加专属客服微信，秒沟通</li>
                <li class="icon_tel"><a :href="'tel:'+info.bid_ask_phone_dial">客服电话：{{info.bid_ask_phone}}</a></li>
            </ul>
            <div class="popWorks">
                <a href="javascript:;" @click="contactPop=false">取消</a>
            </div>
        </div>
    </van-popup>
    <van-popup v-model="qrPop" round>
        <div class="qrPop">
            <h3>加专属客服微信，秒沟通</h3>
            <div class="wxCode">咨询竞拍业务</div>
            <!-- <div class="wxCode">微信号：{{info.bid_ask_wechat_number}} <i :data-clipboard-text="info.bid_ask_wechat_number" class="clipboard">复制</i></div> -->
            <p class="wxPic">
                <span><img :src="info.bid_ask_wechat_pic" alt=""></span>
            </p>
            <div class="wxStep">
                <span>
                    <img src="../assets/img/icon_saveWx.png" alt="">
                    保存二维码
                </span><i></i>
                <span><img src="../assets/img/icon_openWx.png" alt="">
                    打开微信</span><i></i>
                <span><img src="../assets/img/icon_scanWx.png" alt="">
                    扫一扫加好友</span>
            </div>
        </div>
    </van-popup>
</div>
</template>

<script>
import ClipboardJS from "clipboard";
export default {
    props: {
        info: {
            type: Object
        },
        contactPop: {
            type: Boolean,
            default: false
        }
    },
    name: "contact",
    data() {
        return {
            qrPop: false,
            dataStatus: null
        }
    },
    mounted() {
        console.log(this.dataStatus, 'dataStatus')
        this.copyToClipBoard()
        console.log(this.info, 'info')
    },
    methods: {
        contactPopFun(){
            if(this.info&&this.info.live_info&&this.info.live_info.bid_type==1){
                location.reload();
            }else{
                this.contactPop=true
            }
        },
        copyToClipBoard(e) {
            var clipboard = new ClipboardJS(".clipboard");
            clipboard.on("success", e => {
                this.$toast("复制成功！");
                e.clearSelection();
            });

            clipboard.on("error", e => {
                this.$toast("复制失败！");
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.contactUs {
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px 8px 8px 8px;
    background: #fff;
    padding: 0.1rem;
    text-align: center;
    img{
        width: 1.5rem;
        height: 1.5rem;
    }
    span{
        display: block;
        font-size: 0.5rem;
    }
}

.contactPop {
    border-radius: .4rem;
    width: 16.75rem;

    h3 {
        text-align: center;
        line-height: 1.2rem;
        font-size: .8rem;
        color: #27282d;
        font-weight: bold;
        padding: 1.2rem 0 .5rem;
    }

    p {
        text-align: center;
        line-height: 1rem;
        font-size: .7rem;
        color: #666;
        margin-bottom: 1.2rem;
    }

    ul {
        padding: 0 2rem;
    }

    li {
        height: 2.2rem;
        border-radius: 1.1rem;
        border: .1rem solid #18BD6F;
        display: flex;
        align-items: center;
        font-size: .7rem;
        justify-content: left;
        margin-bottom: 1rem;
        color: #18bd6f;
        font-weight: bold;
        background-repeat: no-repeat;
        background-position: .8rem center;
        background-size: 1.5rem;
        padding-left: 2.7rem;

        a {
            color: #18bd6f;
        }
    }

    .icon_wx {
        background-image: url("../assets/img/icon_wx.png");
    }

    .icon_tel {
        background-image: url("../assets/img/icon_tel.png")
    }

    li:last-child {
        margin-bottom: 0;
    }

    .popWorks {
        text-align: center;
        border-top: .025rem solid #DDDEE3;
        margin-top: 1.2rem;

        a {
            height: 2.2rem;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            color: #27282d;
            font-size: .8rem;
        }
    }
}

.qrPop {
    border-radius: .4rem;
    width: 16.75rem;

    h3 {
        text-align: center;
        line-height: 1.2rem;
        font-size: .8rem;
        color: #27282d;
        font-weight: bold;
        padding: 1.2rem 0 .5rem;
    }

    .wxCode {
        font-size: .7rem;
        text-align: center;
        line-height: 1rem;
        color: #666666;

        i {
            border-left: .025rem solid #D8D8D8;
            margin-left: .4rem;
            padding-left: .4rem;
            color: #18bd6f;
        }
    }

    .wxPic {
        text-align: center;
        position: relative;
        width: 5.5rem;
        height: 5.5rem;
        margin: 1.2rem auto 1.5rem;

        &:before {
            width: .55rem;
            height: .55rem;
            position: absolute;
            border-top: .1rem solid #18bd6f;
            border-left: .1rem solid #18bd6f;
            left: 0;
            top: 0;
            content: ''
        }

        &:after {
            width: .55rem;
            height: .55rem;
            position: absolute;
            border-top: .1rem solid #18bd6f;
            border-right: .1rem solid #18bd6f;
            right: 0;
            top: 0;
            content: ''
        }

        span {
            display: block;
            padding: .55rem;
            width: 5.5rem;
            height: 5.5rem;

            &:before {
                width: .55rem;
                height: .55rem;
                position: absolute;
                border-bottom: .1rem solid #18bd6f;
                border-left: .1rem solid #18bd6f;
                left: 0;
                bottom: 0;
                content: ''
            }

            &:after {
                width: .55rem;
                height: .55rem;
                position: absolute;
                border-bottom: .1rem solid #18bd6f;
                border-right: .1rem solid #18bd6f;
                right: 0;
                bottom: 0;
                content: ''
            }
        }

        img {
            width: 100%;
            height: 100%;
        }
    }

    .wxStep {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 1.3rem;

        span {
            display: inline-flex;
            font-size: .6rem;
            align-items: center;
            justify-content: center;
            line-height: .9rem;
            flex-direction: column;
            width: 4.1rem;

            img {
                width: 1.5rem;
                height: 1.5rem;
                margin-bottom: .5rem;
            }
        }

        i {
            width: .5rem;
            height: .7rem;
            background: url("../assets/img/icon_arrow.png") no-repeat;
            background-size: cover;
            margin-bottom: 1.25rem;
        }
    }
}
</style>
